import { axiosRequest } from '@/util/axios-request';
export var get_tab = function get_tab(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/get_tab',
    method: 'get',
    params: data || {}
  });
};

// 获取考勤组数据
export var get_attendance = function get_attendance(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/get_attendance',
    data: data
  });
};

// 保存考勤组数据
export var save_attendance = function save_attendance(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/save_attendance',
    data: data
  });
};

// 获取薪资组数据
export var get_salary = function get_salary(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/get_salary',
    data: data
  });
};

// 保存薪资组数据
export var save_salary = function save_salary(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/save_salary',
    data: data
  });
};

// 获取税组数据
export var getTax = function getTax(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/get_tax',
    data: data
  });
};

// 保存税组数据
export var saveTax = function saveTax(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/save_tax',
    data: data
  });
};

// 获取税组数据
export var getSocialSecurity = function getSocialSecurity(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/get_social_security',
    data: data
  });
};

// 保存社保组数据
export var saveSocialSecurity = function saveSocialSecurity(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/save_social_security',
    data: data
  });
};

// 计薪方案-其他设置列表
export var getDeductSort = function getDeductSort(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/getDeductSort',
    data: data
  });
};

// 计薪方案-其他设置—保存
export var saveDeductSort = function saveDeductSort(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/saveDeductSort',
    data: data
  });
};